import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import {
  RecipeStateKey,
  CriteriaStateKey,
} from '@apps/main/modules/state/state';

import { injectStrict } from '@libs/utils';

import { useMetaStore } from '../meta/metaStore';

import { getRecipeForShareWidget } from './shareWidgetStoreLogic';

export const useShareWidgetStore = defineStore('ShareWidgetStore', () => {
  const criteriaState = injectStrict(CriteriaStateKey);
  const recipeState = injectStrict(RecipeStateKey);
  const metaStore = useMetaStore();

  // State
  const showModal = ref<boolean>(false);

  // Actions
  function openModal(): void {
    showModal.value = true;
  }

  function closeModal(): void {
    showModal.value = false;
  }

  // Getters
  const isRecipeValid = recipeState.isRecipeCorrect;

  const recipe = computed(() =>
    getRecipeForShareWidget(
      criteriaState.itineraryCriteria.value,
      metaStore.metaAffiliateId
    )
  );

  return {
    // State
    showModal,

    // Actions
    openModal,
    closeModal,

    // Getters
    isRecipeValid,
    recipe,
  };
});
